import React__default from 'react';
import { useBloomreachPageRoutes } from '@grandvisionhq/bloomreach';
import { Button } from '@grandvisionhq/common';
import { Text, Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';
import { QueryString } from '@grandvisionhq/utils';
import { usePreferredStore } from '../../../../Profile/hooks/use-preferred-store.js';
import AppointmentsList from '../AppointmentsList/AppointmentsList.js';

const AppointmentBody = ({ appointments  })=>{
    const { getLabel  } = useIntl();
    const { data , error: storeError  } = usePreferredStore();
    const storeId = data === null || data === void 0 ? void 0 : data.storeCode;
    const { routes  } = useBloomreachPageRoutes();
    var ref;
    const bookAppointmentRoute = (ref = routes['appointment-book']) !== null && ref !== void 0 ? ref : '';
    const getBookAppointmentRoute = !storeId || storeError ? bookAppointmentRoute : `${bookAppointmentRoute}/what${QueryString.stringify({
        storeId
    })}`;
    return /*#__PURE__*/ React__default.createElement(React__default.Fragment, null, /*#__PURE__*/ React__default.createElement(Text, null, getLabel('appointments.overview.message')), /*#__PURE__*/ React__default.createElement(Button, {
        href: getBookAppointmentRoute,
        caption: getLabel('appointments.bookAppointment'),
        size: "small",
        className: "appointment-body__button",
        variant: "outline"
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "small"
    }, getLabel('account.appointments.upcoming')), appointments.length < 1 ? /*#__PURE__*/ React__default.createElement(Text, null, getLabel('appointments.noAppointments.message')) : /*#__PURE__*/ React__default.createElement(AppointmentsList, {
        appointments: appointments
    }));
};
var AppointmentBody$1 = AppointmentBody;

export { AppointmentBody$1 as default };
//# sourceMappingURL=AppointmentBody.js.map
